import React from 'react'
import { NoneLabelProps } from './NoneLabel.types'
import styles from './NoneLabel.module.scss'
import cl from 'classnames'
import { Text2 } from '../Text2'

const NoneLabelComponent = (props: NoneLabelProps) => {
  const {
    label = 'None',
    className,
    style
  } = props

  return (
    <Text2 className={cl(styles.noneText, className)} style={style}>
      {label}
    </Text2>
  )
}

const NoneLabel = NoneLabelComponent
export { NoneLabel }
